function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationPoint = function SvgExclamationPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.6 5.217H.4L.094 2.244V0h1.824v2.244L1.6 5.217zM1 8c-.553 0-1-.426-1-.954 0-.527.447-.953 1-.953.553 0 1 .426 1 .953C2 7.574 1.553 8 1 8z",
    fill: props.fill
  }));
};
export default SvgExclamationPoint;